import React from 'react';
import PropTypes from 'prop-types';
import { Radio, Form } from 'antd';

import FormLabel from 'components/FormLabel/FormLabel';

const FormItem = Form.Item;
const { Button, Group } = Radio;

const FormRadio = ({ label, name, disabled, selections, buttonStyle, extraProps, requiredErrorMessage }) => {
  const generatePropsForRules = () => {
    const rules = [];
    if (requiredErrorMessage && typeof requiredErrorMessage === 'string') {
      rules.push({
        required: true,
        message: requiredErrorMessage
      });
    }
    return rules;
  };

  return (
    <>
      {label && <FormLabel>{label}</FormLabel>}
      <FormItem name={name} rules={generatePropsForRules()}>
        <Group disabled={disabled} {...extraProps} buttonStyle={buttonStyle}>
          {selections.map(selection => (
            <Button value={selection.value} key={selection.value} style={selection.style}>
              {selection.label}
            </Button>
          ))}
        </Group>
      </FormItem>
    </>
  );
};

FormRadio.propTypes = {
  label: PropTypes.string,
  name: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.array.isRequired]),
  disabled: PropTypes.bool,
  buttonStyle: PropTypes.string,
  selections: PropTypes.array,
  extraProps: PropTypes.object
};

FormRadio.defaultProps = {
  buttonStyle: 'solid',
  disabled: false,
  extraProps: {}
};

export default FormRadio;
